import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  CaixaCourse,
  CaixaPartner,
  CaixaSmartZapUser,
  CaixaSmartZapUserSignUpDto,
  CaixaSmartZapUserUpdateDto,
  CourseEnrollmentDto,
  CourseListFilter,
  PartnerType,
} from '../models';
import { CaixaClient } from './caixa.client';
import { PageDto } from '../../regulatory-compliance-sdk';

@Injectable({
  providedIn: 'root',
})
export class CaixaApi {
  constructor(private http: CaixaClient) {}

  getCourses(filter: CourseListFilter): Observable<CaixaCourse[]> {
    return this.http.get<PageDto<CaixaCourse>>('/courses', filter).pipe(map((response) => response.items));
  }

  searchUser(cpf: string): Observable<CaixaSmartZapUser> {
    return this.http.get<CaixaSmartZapUser>('/users/find', { search: cpf });
  }

  signUpUser(userSignUpDto: CaixaSmartZapUserSignUpDto) {
    return this.http.post<CaixaSmartZapUser>('/users', userSignUpDto);
  }

  updateUser(userUpdateDto: CaixaSmartZapUserUpdateDto) {
    return this.http.patch<unknown>('/users', userUpdateDto);
  }

  searchPartner(search: string, partnerType: PartnerType): Observable<PageDto<CaixaPartner>> {
    return this.http.get<PageDto<CaixaPartner>>('/partners', { search, partnerType });
  }

  enroll(enrollmentDto: CourseEnrollmentDto, courseId: string) {
    return this.http.post<unknown>(`/courses/${courseId}/enroll`, enrollmentDto);
  }

  cancelUserEnrollment(userId: string) {
    return this.http.post<unknown>(`/users/${userId}/give-up`, {});
  }
}
